class CollectionLoad extends HTMLElement {
  constructor() {
    super();
    this.queryCount = document.querySelector('[data-count-increment]') || null;
    this.queryTotal = document.querySelector('[data-count-total]') || null;
    this.successBar = document.querySelector('[data-success-bar]') || null;
    this.dataTrigger = document.querySelector('[data-trigger]') || null;
    this.dataTriggerAll = document.querySelector('[data-trigger-all]') || null;
    this.loadingAll = document.querySelector('[data-loading-text-all]') || null;

    this.count = 2;
    this.loadMore = null;
  }

  connectedCallback() {
    if (document.readyState === 'complete') {
      this.init();
    } else {
      window.addEventListener('load', () => {
        this.init();
      });
    }
  }

  getCount() {
    if (!this.queryCount) return;
    // count all product tiles in document
    const productArea = document.getElementsByTagName('product-tile');
    this.items = productArea.length;

    // set x of y (x) to number of product tiles active on the page
    this.queryCount.innerHTML = this.items;

    // value of progress bar set to current item count
    this.successBar.value = this.items;
    if (Number(this.queryTotal.innerText) < (9 * (this.count - 1))) {
      document.querySelector('[data-count-q]').style.display = 'none';
    }
  }

  init() {
    this.loadMore = document.querySelector('[data-load-more]');
    this.loadAll = document.querySelector('[data-load-all]');
    this.getCount();
    this.count = 2;
    this.dataTrigger.addEventListener('click', () => {
      this.fetchHtml()
        .then(() => this.getCount());
    });
    this.dataTriggerAll.addEventListener('click', () => {
      const loadText = this.loadingAll.getAttribute('data-loading-text-all');
      this.loadingAll.textContent = loadText;
      const all = true;
      this.fetchHtml(all)
        .then(() => this.getCount());
    });
  }

  async fetchHtml(all = false) {
    if (all === false) {
      await fetch(`${window.location.search ? `${window.location.search}&` : '?'}sections=collection-product-grid&page=${this.count}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.text())
        .then((parsedState) => {
          const JSONData = JSON.parse(parsedState);
          const newNode = document.createElement('div');
          newNode.innerHTML = JSONData['collection-product-grid'];

          if (newNode.querySelector('[data-content]').children.length) {
            this.count += 1;
            this.appendChild(newNode);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    } else {
      await fetch(`${window.location.search ? `${window.location.search}&` : '?'}sections=collection-product-grid&page=${this.count}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.text())
        .then((parsedState) => {
          const JSONData = JSON.parse(parsedState);
          const newNode = document.createElement('div');
          newNode.innerHTML = JSONData['collection-product-grid'];

          if (newNode.querySelector('[data-content]').children.length) {
            this.count += 1;
            this.appendChild(newNode);
          }
        })
        .then(() => this.getCount())
        .then(() => this.fetchHtml(all = true))
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }
}

customElements.define('collection-load', CollectionLoad);
